import { useSelector } from 'react-redux'

import saga from 'Modules/auth/store/saga'
import reducer from 'Modules/auth/store/reducer'
import { useInjectReducer, useInjectSaga } from 'Stores'
import { makeSelectAuthentication } from 'Modules/auth/store/selectors'
import { ROLE_TYPE } from '../Constants/permission'

export const useAuth = () => {
  useInjectSaga({ key: 'auth', saga })
  useInjectReducer({ key: 'auth', reducer })

  const { isCheck2FA, isEnable2FA, isLoading, error, authenticated, profile, metaData, success } = useSelector(
    makeSelectAuthentication()
  )

  return {
    isCheck2FA,
    isEnable2FA,
    isLoading,
    error,
    authenticated,
    profile,
    metaData,
    success
  }
}

export const useRoles = () => {
  useInjectSaga({ key: 'auth', saga })
  useInjectReducer({ key: 'auth', reducer })

  const { profile } = useSelector(
    makeSelectAuthentication()
  )

  const isSystemAdmin = profile?.role?.includes?.(ROLE_TYPE.SYSTEM_ADMIN)
  const isCompanyAdmin = profile?.role?.includes?.(ROLE_TYPE.COMPANY_ADMIN)
  const isPortfolioAdmin = profile?.role?.includes?.(ROLE_TYPE.PORTFOLIO_ADMIN)
  const isEditor = profile?.role?.includes?.(ROLE_TYPE.EDITOR)
  const isUser = profile?.role?.includes?.(ROLE_TYPE.USER)

  return { isSystemAdmin, isCompanyAdmin, isPortfolioAdmin, isEditor, isUser }
}
